import {
  ArticleTypeLabelContainer,
  ArticleTypeLabel,
} from '@buildwise/pages/knowledge/components/ArticleInteractions';
import { ArticleSourceType, ArticleType } from '@buildwise/pages/knowledge/hooks/useArticlesQuery';
import { Chip } from '@mui/material';
import { theme } from 'config/theme';
import ChatQuoteFillIcon from 'remixicon-react/ChatQuoteFillIcon';
import FileListFillIcon from 'remixicon-react/FileListFillIcon';
import QuestionFillIcon from 'remixicon-react/QuestionFillIcon';
import { ReactComponent as RetrospectiveFillIcon } from 'assets/icons/RetrospectiveFillIcon.svg';

type ArticleTypeLabelProps = {
  article: ArticleType;
};

function RenderArticleTypeLabel({ article }: ArticleTypeLabelProps) {
  return (
    <Chip
      label={
        <>
          {article.articleType === ArticleSourceType.QUESTION ? (
            <ArticleTypeLabelContainer>
              <QuestionFillIcon color={theme.palette.custom.dodgerBlue} size={18} />
              <ArticleTypeLabel>Question</ArticleTypeLabel>
            </ArticleTypeLabelContainer>
          ) : article.articleType === ArticleSourceType.SUGGESTION ? (
            <ArticleTypeLabelContainer>
              <ChatQuoteFillIcon color={theme.palette.custom.cloverGreen} size={18} />
              <ArticleTypeLabel>Suggestion</ArticleTypeLabel>
            </ArticleTypeLabelContainer>
          ) : article.articleType === ArticleSourceType.LESSON ? (
            <ArticleTypeLabelContainer
              sx={{ '& svg path': { fill: theme.palette.custom.lavenderIndigo } }}
            >
              <RetrospectiveFillIcon width={18} />
              <ArticleTypeLabel>Learning</ArticleTypeLabel>
            </ArticleTypeLabelContainer>
          ) : (
            <ArticleTypeLabelContainer>
              <FileListFillIcon color={theme.palette.custom.pirateGold} size={18} />
              <ArticleTypeLabel>Post</ArticleTypeLabel>
            </ArticleTypeLabelContainer>
          )}
        </>
      }
      variant="outlined"
      sx={{
        my: 0.5,
        border: 'none',
        backgroundColor:
          article.articleType === ArticleSourceType.QUESTION
            ? theme.palette.custom.lightBlue
            : article.articleType === ArticleSourceType.SUGGESTION
              ? theme.palette.custom.chinook
              : article.articleType === ArticleSourceType.LESSON
                ? theme.palette.custom.bluishPurple
                : theme.palette.custom.paleGold,
        '&:hover': {
          backgroundColor:
            article.articleType === ArticleSourceType.QUESTION
              ? theme.palette.custom.lightBlue
              : article.articleType === ArticleSourceType.SUGGESTION
                ? theme.palette.custom.chinook
                : article.articleType === ArticleSourceType.LESSON
                  ? theme.palette.custom.bluishPurple
                  : theme.palette.custom.paleGold,
        },
      }}
    />
  );
}

export default RenderArticleTypeLabel;
